import apiClient from './apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type { EorpDocumentResponse, EorpNewResponse } from './eorpService.types'

export type { EorpDocumentResponse, EorpNewResponse } from './eorpService.types'

/** Fetch Explanation of Reimbursement Process content for the agreement popup. */
export async function fetchEorpNew(): Promise<EorpNewResponse> {
  const response = await apiClient.get<EorpNewResponse>('/api/eorp_new')
  return response.data
}

/** Alias for reimbursements feature parity. */
export async function getNewEorp(): Promise<EorpNewResponse> {
  return fetchEorpNew()
}

/**
 * Document-scoped EORP section opened from service-agreement "Click here…" links
 * (`/explanation-service-aggrement/:id` in Angular).
 */
export async function fetchEorpByDocumentId(documentId: number): Promise<EorpDocumentResponse> {
  try {
    const response = await apiClient.get<EorpDocumentResponse>(`/api/eorp/${documentId}`)
    return response.data
  } catch (error) {
    // Re-throw the original API error so showApiError can surface Angular's
    // `error.error` body (e.g. a descriptive 404 message) instead of a generic string.
    if (error && typeof error === 'object') throw error
    throw new Error(extractErrorMessage(error) || 'Document not found')
  }
}

export async function downloadNewEorpPdf(): Promise<Blob> {
  const response = await apiClient.get<Blob>('/api/eorp_new/pdf', {
    responseType: 'blob',
  })
  return response.data
}
